import { useEffect } from 'react'

interface UseGigAssistContentProps {
  contentId: string
  visibleHeight: number
  isMobile: boolean
}

export const useGigAssistContent = ({ contentId, visibleHeight, isMobile }: UseGigAssistContentProps) => {
  useEffect(() => {
    const contentElement = document.getElementById(contentId)
    if (contentElement) {
      const styles = {
        maxHeight: isMobile ? `auto` : 'auto',
        height: isMobile ? `${visibleHeight}px` : '100vh',
        minHeight: isMobile ? `${visibleHeight}px` : '100vh',
      }

      // применяем стили
      Object.entries(styles).forEach(([property, value]) => {
        contentElement.style[property as any] = value
      })

      return () => {
        // очищаем стили
        Object.keys(styles).forEach((property) => {
          contentElement.style[property as any] = ''
        })
      }
    }
  }, [contentId, visibleHeight])
}
